import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";
import _ from "lodash";
import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import Loading from "pages/Custom/Loading";
import { deleteSmsTemplate, getSmsTemplateList, saveSmsTemplate } from "crud/alarm.crud";

const TemplateManagement = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputCondition, setInputCondition] = useState({})
  const [modalShow, setModalShow] = useState({
    fileUpload: false,
    delete: false
  })
  const [page, setPage] = useState(1)
  const [refresh, setRefresh] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  
  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getDataList = async () => {
    if (isLoading || isListEnd)
      return
    
    setIsLoading(true)
    try {
      const params = {
        page: page
      }

      const response = await getSmsTemplateList(params);      
      if (response.status === 200) {
        const content = response.data?.results || [];
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
      setRefresh(false)
    } catch (error) {
      setIsLoading(false)
      setRefresh(false)
    }
  }

  const deleteTemplate = async (item) => {
    if(confirm('해당 템플릿을 삭제하시겠습니까?')){
      const params = {
        id: item.id,
      }
      const rs = await deleteSmsTemplate(params)
      if (rs.status === 200) {
        alert('정상적으로 삭제하였습니다.')
        setDataList(prev => prev.filter(v => v.id !== item.id))
      } else {
        alert('삭제에 실패하였습니다.')
      }
    }
  }

  const registerTemplate = async () => {
    const params = {
      subject: inputCondition.subject,
      content: inputCondition.content,
    }
    const rs = await saveSmsTemplate(params)
    if (rs.status === 200) {
      alert('정상적으로 등록되었습니다.')
      setIsListEnd(false)
      if (page === 1) {        
        setRefresh(true)
      } else {
        setPage(1)
      }
    } else {
      alert('등록에 실패하였습니다.')
    }
  }

  const changeInputCondition = (key, value) => {
    setInputCondition(prev => ({ ...prev, [key]: value }))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }
  
  useEffect(() => {
    if (refresh){
      getDataList()
    }      
  }, [refresh])

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>템플릿 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="메시지 관리" breadcrumbItem="템플릿 관리" />

          <Row>
            <Col xl={5} lg={12}>
              <div className="d-flex align-items-center margin-bottom-12">
                <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
                <p className="font-weight-bold font-size-15 mb-0 margin-left-6">템플릿 생성</p>
              </div>

              <div className="d-flex w-100 gap-30 align-items-center">
                <div className="email-rightbar flex-grow-1">
                  <Card className="mb-0">
                    <CardBody className="padding-0">
                      <table className="input-table">
                        <tbody>
                          <tr>
                            <td className="col-10 padding-left-8 primary-bg white-text">제목</td>
                            <td className="col-20">
                              <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="제목을 입력해 주세요." value={inputCondition.subject} onChange={(e) => {
                                changeInputCondition('subject', e.target.value)
                              }} />
                            </td>
                          </tr>
                          <tr>
                            <td className="col-10 padding-left-8 primary-bg white-text">메시지</td>
                            <td className="col-20">
                              <textarea className="waver-text-box w-100 border-radius-0" placeholder="메시지를 입력해 주세요." value={inputCondition.content}
                              onChange={(e)=>{
                                changeInputCondition('content', e.target.value);
                              }} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </CardBody>
                  </Card>
                </div>
              </div>
              <div className="d-flex justify-content-end margin-top-13">
                <button type="button" className="custom-btn border-radius-0 secondary-bg white-text button-border margin-right-0" onClick={() => {
                  if (!(inputCondition.subject && inputCondition.content)) {
                    modalOpen('error')
                  } else {
                    registerTemplate()
                  }
                }}>템플릿 추가</button>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-2 margin-top-25">
                <p className="mb-0 font-size-16"><span className="font-weight-bold">템플릿 목록</span> [ 건수 : {dataList.length}건 ]</p>
              </div>

              <Card>
                <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                  <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                      <thead className="chart-thead">
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">템플릿명</th>
                          <th scope="col">템플릿 내용</th>
                          <th scope="col">삭제</th>
                        </tr>
                      </thead>
                      <tbody className="chart-tbody">
                        {dataList.map((item, index) => {
                          return (
                            <tr key={item.id + '_' + index}>
                              <td>{item.id}</td>
                              <td>{item.subject}</td>
                              <td>{Util.textSubstring(item.content, 25)}</td>
                              <td>
                                <div className="btn-group waver-common-btn-group">
                                  <Button type="button" size="sm" className="waves-effect center-btn btn-common small disactive" onClick={(e) => {
                                    e.stopPropagation()
                                    deleteTemplate(item)
                                  }}>삭제</Button>
                                </div>
                              </td>
                            </tr>
                          )
                        })}
                        {dataList.length === 0 &&
                          <tr>
                            <td scope="row" colSpan="14">데이터가 없습니다.</td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>
                </CardBody>
                {isLoading && <Loading />}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        title={'템플릿 추가'}
        show={modalShow.error}
        onHide={() => {
          modalClose('error')
        }}
        size="md"
        bodyChildren={
          <p>템플릿명과 내용을 입력해 주세요.</p>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              modalClose('error')
            }}>
              확인
            </button>
          </div>
        }
      >
      </Modal>
    </React.Fragment>
  )
}

export default TemplateManagement
